<template>
    <div id="main-grid" class="grid simple main borderRadius12px" style="background: #e5e9ec">
      <div class="well form-group" style="background: #e5e9ec">
  
        <!--title -->
        <div class="grid-title no-border borderTop">
          <h4 style="padding-left: 6px"> {{ i18nValues["campaignEdition"] }} </h4>
        </div>        
  
        <!-- body -->
        <div class="grid-body no-border borderBottom">
          <el-form v-loading="loading != 0" :model="campaign" ref="formCampaign" :rules="rules">
            <div class="gridTemplate">
  
                <!-- Name -->    
                <el-form-item :label="i18nValues['name']" prop="name"> 
                  <el-input v-model="campaign.name" maxlength="30"></el-input>
                </el-form-item>      

                <!-- Date -->
                <el-form-item :label="i18nValues['date']" prop="date">
                    <div class="input-group">
                        <el-date-picker 
                            type="date" 
                            class="calendar"
                            format="dd/MM/yyyy"
                            v-model="campaign.date"
                            placeholder="Select date">
                        </el-date-picker>
                        <span class="input-group-addon primary el-input__suffix icon">
                        <span class="arrow"></span>
                            <i class="fa fa-calendar-alt"></i>
                        </span>                                
                    </div>
                </el-form-item>
  
            </div>          
          </el-form>
  
          <!-- CANCEL/ACTIVATE/SAVE --> 
          <div class="full-width d-flex justify-content-end mt-2">
            <el-button :loading="loading" size="small" @click="cancel()">
              {{ i18nValues["cancel"] }}
            </el-button>
            <el-button v-if="this.id != 0" icon="fas fa-upload" :loading="loading" size="small" class="btn-primary" @click="activate()">
              {{ i18nValues["activate"] }}
            </el-button> 
            <el-button icon="fas fa-check" :loading="loading" size="small" class="btn-primary" @click="save()">
              {{ i18nValues["save"] }}
            </el-button>
          </div>  
  
        </div>      
      </div>
    </div>
  </template>
  
  <script>
  import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars
  export default {
    name: "CampaigneEdition",  
  
    created(){
  
      if(this.id != 0 ){
          this.retrieveById();
      }
  
      this.rules= {
        name:[{required: true, message: this.i18nValues["requiredValue"], trigger: 'blur' }],
        dataType:[{required: true, message: this.i18nValues["requiredValue"], trigger: 'blur' }],
      };

      this.rulesOption= {
        name:[{required: true, message: this.i18nValues["requiredValue"], trigger: 'blur' }],
      };
  
    // Capture initial query to preserve filters/pagination when returning
    this.returnQuery = { ...this.$route.query };

    },
  
    components: {
    },
  
    computed: {
      loading: get("campaign/loading"),
      globalFieldSite: get("globalFieldSite"),
    },
  
    props:["id"],
  
    data() {
      return {
        campaign: {},
  
      rules:{},
      returnQuery: {},
      };
    },
  
    methods: {
      save(){
        this.$refs["formCampaign"].validate((valid) => {
          if(valid){
            this.campaign.fieldSite = this.globalFieldSite;
            this.$store.dispatch("campaign/saveCampaign", this.campaign).then((res) =>{            
              if(res.status == "OK"){
                  this.$notify.success({
                      title: this.i18nValues["succes"],
                      message: this.i18nValues["campaignSaved"],
                      position: "bottom-right",
                  });
                  this.$root.$refs.App.retrieveAllCampaigns();
                  this.$router.push({name:"CampaignAdmin", query: this.returnQuery});    
              } else {
                  this.$notify.error({
                      title: this.i18nValues["error"],
                      message: this.i18nValues["cantDeleteCampaign"],
                      position: "bottom-right",
                  });
              }           
            });
          }
        });
      },
  
      cancel(){
          this.$router.push({name:"CampaignAdmin", query: this.returnQuery});
      },
  
      retrieveById(){
          this.$store.dispatch("campaign/retrieveCampaignById", { id: this.id }).then((res)=>{
              this.campaign = res;
          });       
      },

      addOption(){
        this.$refs["formOption"].validate((valid) => {
          if(valid){
            this.optionsList.push(this.option);
            this.option = {};
          }
        });
      },

      removeOption(option){
        this.optionsList.splice(this.optionsList.indexOf(option), 1);
      },

      activate(){
        this.$store.dispatch("campaign/activateCampaign", { id: this.id }).then((res)=>{
          if(res.status == "OK"){
                  this.$notify.success({
                      title: this.i18nValues["succes"],
                      message: this.i18nValues["campaignActivated"],
                      position: "bottom-right",
                  }); 
                  this.$router.push({name:"CampaignAdmin", query: this.returnQuery});   
              } else {
                  this.$notify.error({
                      title: this.i18nValues["error"],
                      message: this.i18nValues["cantActivateCampaign"],
                      position: "bottom-right",
                  });
              } 
        });  
      }
    },
  
  }
  </script>
  
  <style>
  
  </style>